module.exports = __webpack_public_path__ + "img/loginTitle.47270691.png";